import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { myLocalStorage } from '@/scripts/utils';
import { languageMap } from '@/configs/i18n';

export const i18nPromise = i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  resources: languageMap,
  lng: getUserLanguage(),
  interpolation: {
    escapeValue: false,
  },
});

export function getUserLanguage(): string {
  // TODO
  // return myLocalStorage.getItem('language') || navigator.language;
  return 'en';
}

export function setUserLanguage(language: string | undefined) {
  if (language) {
    myLocalStorage.setItem('language', language);
  } else {
    myLocalStorage.removeItem('language');
  }
}

export { i18n };
